import * as React from 'react';
import styled from 'styled-components';
import { TextField } from '@mollybet/ui';
import { CurrencyAdornments } from 'common/configs/currency';

interface FieldProps {
  align: string;
}

const AlignedField = styled(TextField)<FieldProps>`
  input {
    text-align: ${(props) => props.align || 'left'};
  }
`;

const CurrencyInput = (props) => {
  const { currency, ...rest } = props;
  let [side, symbol] = ['left', ''];

  if (currency in CurrencyAdornments) {
    [side, symbol] = CurrencyAdornments[currency];
  }

  const adornmentProp = {
    [side]: symbol,
  };

  return <AlignedField align={side} {...adornmentProp} {...rest} />;
};

export default CurrencyInput;
